var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRmsv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 21",
    style: {
      enableBackground: "new 0 0 30 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 14,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,3.349V2c0-0.553-0.447-1-1-1h-2c-0.553,0-1,0.447-1,1v1.349C18.671,4.174,17,6.389,17,9h12    C29,6.389,27.329,4.174,25,3.349z M24,3h-2V2h2V3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.979,11.732l-5.183,2.289c-0.06,0.026-0.132,0.006-0.166-0.052l-1.597-2.625c-0.889-1.481-2.488-2.346-4.215-2.346    h-6.59c-4.256,0-4.224,3.803-4.229,4.125l0.002,7.875H3l0.016-8h0.985l0.007,8H12v-6.703c0-0.436,0.288-0.789,0.723-0.789    c0.276,0,0.5,0.145,0.644,0.38l1.87,3.115c0.207,0.34,0.623,0.473,0.984,0.313l6.881-3.043c0.703-0.311,1.019-1.131,0.707-1.83    C23.498,11.739,22.677,11.425,21.979,11.732z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmsv);
export default __webpack_public_path__ + "static/media/RMSV.c9f73a7a2dcb77a067c12d2f2268be45.svg";
export { ForwardRef as ReactComponent };